module.exports = __webpack_public_path__ + "img/aussen2.024d2ab8.jpg";